// FIXME: Ponder whether this goes to domains/users

import type {
  AuthenticatedUser,
  AuthenticatedUserRole,
} from '@omnipresentgroup/auth';
import { AUTH0_ROLES } from '@omnipresentgroup/constants';
import {
  type User,
  type UserRole,
  UserRoleType,
} from '@omnipresentgroup/types';

const rankFrom = (role: UserRole | AuthenticatedUserRole) => {
  const ranks: Record<UserRoleType, number> = {
    [UserRoleType.BENEFITS_SPECIALIST]: 3,
    [UserRoleType.INTERNATIONAL_EXPANSION]: 3,
    [UserRoleType.ADMIN]: 3,
    [UserRoleType.MANAGER]: 2,
    [UserRoleType.LSP]: 2,
    [UserRoleType.EMPLOYEE]: 1,
    [UserRoleType.CS]: 0,
    [UserRoleType.OMNI_HR]: 0,
    [UserRoleType.PAYROLL]: 0,
    [UserRoleType.FINANCE]: 0,
    [UserRoleType.CONTRACTOR]: 0,
  };

  return ranks[role.type];
};

export const getUserMainRole = (
  roles: UserRole[] | AuthenticatedUserRole[],
) => {
  return [roles].flat().reduce(
    (bestSoFar, role) =>
      rankFrom(role) > rankFrom(bestSoFar) ? role : bestSoFar,
    // eslint-disable-next-line no-magic-numbers
    roles[0],
  );
};

export const getUserRole = (user: User, userRole: UserRoleType) =>
  Object.values(user.roles).find((role) => role.type === userRole);

const getScopes = (user: AuthenticatedUser) => {
  const roles = user[AUTH0_ROLES];

  if (!roles) {
    return [];
  }

  const allScopes = roles.reduce((scopes, role) => {
    return role.scopes ? [...scopes, ...role.scopes] : scopes;
  }, [] as string[]);

  return [...new Set(allScopes)];
};

const hasScope = (user: AuthenticatedUser, searchScope?: string) =>
  getScopes(user).some((scope) => scope === '*' || scope === searchScope);

export const hasSuperManagerScope = (user: AuthenticatedUser) =>
  hasScope(user, 'employees:*');

export const hasFinanceScope = (user: AuthenticatedUser) =>
  hasScope(user, 'finance:*');

export const hasPayrollScope = (user: AuthenticatedUser) =>
  hasScope(user, 'payroll:*');
